<template>
  <!-- ROTATING MESSAGES -->
  <div class="info" ref="info">EVERY. HOUR. COUNTS.</div>
</template>

<script>
export default {
  name: "DashboardMessage",
  data() {
    return {
      words: [
        "EVERY. HOUR. COUNTS.",
        "SO MAKE IT FUCKING COUNT.",
        "DO INSANELY GREAT WORK.",
        "BE BETTER EACH TIME.",
        "GO THE EXTRA MILE.",
        "GO BEYOND EXPECTATIONS.",
        "MAKE SOMETHING WORTH USING.",
        "MAKE SOMETHING WORTH PEOPLE'S TIME.",
        "MAKE SOMETHING PEOPLE LOVE.",
        "KEEP HIGH STANDARDS.",
        "CARE DEEPLY ABOUT THE DETAILS.",
        "AND KEEP GOING.",
      ],
      currentStep: 0,
      oldWord: "",
    };
  },
  mounted() {
    setTimeout(this.changeWord, 600);
  },
  methods: {
    changeWord() {
      this.oldWord = this.$refs.info.innerHTML;

      // check if there is a word atm or not
      if (this.oldWord.length < 1) {
        if (this.currentStep !== this.words.length - 1) {
          this.currentStep++;
        } else {
          this.currentStep = 0;
        }
        this.addNextWord();
      } else {
        setTimeout(this.deleteWord, 400);
      }
    },

    deleteWord() {
      //   let WordLength = this.oldWord.length;
      let currentWord = this.$refs.info.innerHTML;
      let currentLength = currentWord.length;

      // The word is deleted so, start adding in the new one
      if (currentLength < 1) {
        this.changeWord();
        return;
      }

      // Remove a charachter
      this.$refs.info.innerHTML = currentWord.substring(0, currentLength - 1);

      setTimeout(this.deleteWord, 100);
    },

    addNextWord() {
      let currentWord = this.$refs.info.innerHTML;
      let currentLength = currentWord.length;
      let nextWord = this.words[this.currentStep];
      let nextWordLength = nextWord.length;

      if (currentLength === nextWordLength) {
        this.changeWord();
        return;
      }

      // add a charachter
      this.$refs.info.innerHTML = nextWord.substring(0, currentLength + 1);

      setTimeout(this.addNextWord, 100);
    },
  },
};
</script>

<style scoped>
.info {
  font-size: 34px;
}
</style>